import React from "react";
import styles from "./HistoryThroughFacesSection.module.scss";
import Title from "components/title/Title";
import ArticleCard from "components/cards/articleCard/ArticleCard";

const HistoryThroughFacesSection = () => {
  return (
    <div className={styles.historyThroughFacesSectionContainer}>
      <div className="container">
        <Title text={"History Through Faces"} bottomStrokeWidth={"65%"} />
        <div className={styles.cardGrid}>
          <ArticleCard />
          <ArticleCard />
          <ArticleCard />
          <ArticleCard />
          <ArticleCard />
          <ArticleCard />
          <ArticleCard />
          <ArticleCard />
        </div>
        <div className={styles.viewAllCentered}>View All</div>
      </div>
    </div>
  );
};

export default HistoryThroughFacesSection;
